/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Site_LabelInputs */

const en_us2_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where did you measure?`)
};

const pt_br2_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde você mediu?`)
};

const es_419_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde mediste?`)
};

const pt_pt2_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde mediste?`)
};

const fr_fr2_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où as-tu mesuré ?`)
};

const de_de2_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo hast du gemessen?`)
};

const it_it2_body_measures_site_label = /** @type {(inputs: Body_Measures_Site_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove hai misurato?`)
};

/**
* | output |
* | --- |
* | "Where did you measure?" |
*
* @param {Body_Measures_Site_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_site_label = /** @type {((inputs?: Body_Measures_Site_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Site_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_site_label(inputs)
	if (locale === "es-419") return es_419_body_measures_site_label(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_site_label(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_site_label(inputs)
	if (locale === "de-DE") return de_de2_body_measures_site_label(inputs)
	if (locale === "it-IT") return it_it2_body_measures_site_label(inputs)
	return en_us2_body_measures_site_label(inputs)
});
export { body_measures_site_label as "body-measures.site_label" }